










































































































import {
  defineComponent,
  watch,
  toRefs,
  reactive,
  computed
} from '@vue/composition-api';
import { useStore } from '@/utils/use-store';
import { objectDiff } from '@/helpers/functions';
import { Exercise, Practice } from '@/helpers/types';

export default defineComponent({
  name: 'QuestionsForm',

  props: {
    mode: {
      type: String,
      default: () => 'create'
    },
    exercise: {
      type: Object,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    practices: {
      type: Array,
      default: () => []
    }
  },

  setup(props, context) {
    const store = useStore();
    const { exerciseTypes } = store.state;
    const {
      tempExercise,
      submitForm,
      categoryList,
      exercisePractice,
      category,
      archive,
      duplicate,
    } = useEditCreateExercise(props, context);
    const executionTime = computed(() => {
      if (exercisePractice) {
        return exercisePractice.value?.category?.execution_time || 8;
      }
      return 8;
    });

    return {
      category,
      tempExercise,
      exerciseTypes,
      submitForm,
      categoryList,
      exercisePractice,
      executionTime,
      archive,
      duplicate,
    };
  }
});

function useEditCreateExercise(props: any, context: any) {
  const formState = reactive({
    tempExercise: {
      name: '',
      type: 0,
      description: '',
      summary: '',
      instructions: '',
      active: true,
      practice: null,
      image: '',
      execution_time: null
    }
  });

  const categoryList = computed((): any =>
    props.practices.map((pr: Practice) => ({
      id: pr.id,
      name: pr.category.name
    }))
  );
  const exercisePractice = computed({
    get: (): Practice | null => formState.tempExercise.practice,
    set: (val: any) => {
      formState.tempExercise.practice = props.practices.find(
        (pr: Practice) => pr.id === val
      );
    }
  });
  const category = computed(() => exercisePractice.value?.category);

  watch(
    () => props.exercise,
    (exercise, oldExercise) => {
      if (exercise) {
        // formState.tempExercise = Object.assign({}, exercise);
        const temp = JSON.stringify(exercise);
        formState.tempExercise = JSON.parse(temp);
      } else {
        formState.tempExercise = {
          name: '',
          type: 0,
          description: '',
          summary: '',
          instructions: '',
          active: true,
          practice: null,
          image: '',
          execution_time: null
        };
      }
    }
  );

  /**
   * Submit form event
   * */
  async function submitForm() {
    let payload: Exercise;
    if (props.mode === 'edit') {
      payload = objectDiff(props.exercise, formState.tempExercise) as Exercise;
    } else {
      payload = (formState.tempExercise as unknown) as Exercise;
    }
    if (!Object.keys(payload).length) {
      return;
    }
    if (
      ((payload.type && payload.type !== 1) ||
        (props.exercise && props.exercise.type !== 1)) &&
      payload.practice
    ) {
      delete payload.practice;
    }
    if (payload.practice) {
      (payload as unknown as Record<string, any>).practice_id = payload.practice.id;
      delete payload.practice;
    }
    if (context.refs.exerciseForm.validate()) {
      context.emit(`${props.mode}-exercise`, {
        exercise: payload,
        id: props.exercise?.id
      });
    }
  }

  /**
   * Archive exercise
   * @param {string} id
   * */
  function archive(id: string) {
    confirm('Are you sure you want to archive this question?') &&
      context.emit('archive', id);
  }

  async function duplicate() {
    context.emit('duplicate-exercise', formState.tempExercise);
  }

  return {
    ...toRefs(formState),
    submitForm,
    categoryList,
    exercisePractice,
    category,
    archive,
    duplicate,
  };
}
